import * as swcHelpers from '@swc/helpers';

const fromListStoreGroupsQueryToStoreGroup = (data)=>{
    if (!data) {
        return {};
    }
    const sortedStores = [
        ...data.multiStoreGroups,
        ...data.singleStoreGroups
    ].sort((a, b)=>a.name.toLowerCase().localeCompare(b.name.toLowerCase())
    );
    const storeGroups = sortedStores.reduce((acc, value)=>{
        const firstNameStoreLetter = value.name.toUpperCase()[0];
        const existingStore = acc[firstNameStoreLetter];
        const groupedExistingStores = existingStore && [
            ...existingStore,
            value
        ];
        return swcHelpers.objectSpread({}, acc, {
            [firstNameStoreLetter]: groupedExistingStores ? groupedExistingStores : [
                value
            ]
        });
    }, {});
    return storeGroups;
};

export { fromListStoreGroupsQueryToStoreGroup };
//# sourceMappingURL=adapters.js.map
